import { Component, OnInit } from "@angular/core";
import { ViewWillEnter } from "@ionic/angular";
import { Location } from '@angular/common';
import { ActivatedRoute, Router, NavigationStart, NavigationExtras, NavigationEnd } from "@angular/router";
import { ReplaceWorkOrderService } from "../../../../services/replace-work-order.service";
import { WorkOrderProduct } from "../../../../models/work-order-product.model";
import { WorkOrderGarment } from "../../../../models/work-order-garment.model";
import { ToasterService } from "../../../../../../common/services/toaster.service";
import { GtrakAuthService } from "../../../../../authentication/services/gtrak-auth.service";
import { GarmentReportService } from "../../../../../../../app/features/garment-listing/services/garment-report.service";
import { GarmentReportDetail } from "../../../../../../../app/features/garment-listing/models/garment-report-detail.model";
import { GarmentReportSummary } from "../../../../../../../app/features/garment-listing/models/garment-report-summary.model";
import { GarmentReport } from "../../../../../../../app/features/garment-listing/models/garment-report.model";
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalController } from '@ionic/angular';
@Component({
  selector: "app-replace-work-order-page",
  templateUrl: "replace-work-order.page.html",
  styleUrls: [
    "./replace-work-order.page.scss",
    "../../../../styles/g-route.styles.scss",
  ],
})
export class ReplaceWorkOrderPage implements ViewWillEnter, OnInit {
  currentRoute: string;
  stopName: string;
  customerCode: string;
  departmentCode: string;
  employeeCode: string;
  garmentCodes: string[] = [];
  garment: GarmentReport = null;
  garmentSummary: GarmentReportSummary = null;
  garmentDetails: GarmentReportDetail = null;

  loaded: boolean = false;

  garmentDetailsShow: boolean = false;

  woProductList:any[] = [];
  selectedWoProductList: WorkOrderProduct[] = [];

  woGarmentList: any[] = [];

  userId: string | number = null;

  type: string = "XI";
  breadcrumbs=[];
  routeStopName: string = "";
  isButtonDisabled = false;

  constructor(
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private ReplaceWorkOrderService: ReplaceWorkOrderService,
    private toasterService: ToasterService,
    private gtrakAuthService: GtrakAuthService,
     private modalController: ModalController,
    private garmentReportService: GarmentReportService
  ) {
    this.currentRoute = null;
  }

  async ngOnInit(): Promise<void> {
    this.loaded=false;
    //this.getNavigationState();
    this.currentRoute = this.router.url;
    this.stopName = this.route.snapshot.paramMap.get("id");
    this.employeeCode = this.route.snapshot.paramMap.get("eId");
    this.departmentCode = this.route.snapshot.paramMap.get("dId");
    this.customerCode = this.route.snapshot.paramMap.get("cId");

    this.routeStopName = localStorage.getItem('routeStopName');
    this.breadcrumbs.push({ label: 'Home', url: '/route' });
    this.breadcrumbs.push({ label: 'Logsheet', url: '/route/logsheet' });
    this.breadcrumbs.push({ label: 'Stop', url: '/route/logsheet/stop/'+ this.stopName });
    this.userId = await this.gtrakAuthService.user.id;
    await this.getGarment();
    this.loaded=true;
  }
  async ionViewWillEnter(): Promise<void> {
   // await this.getNavigationState();
    this.getGarment();
   
  }

 
    async getGarment(): Promise<void> {
      this.loaded=false;
      this.garmentCodes=[];
      let data = localStorage.getItem("selectedWoProductList");  

      if (data) {
        let dataList = data.split(",");
        for (let i = 0; i < dataList.length; i++) {
          const code = dataList[i].trim(); 
          if (code !== "") {
            this.garmentCodes.push(code);
          }
        }
      }
      await this.ReplaceWorkOrderService
      .GetReplaceGarmentDetails(
        this.garmentCodes
      )
      .then((res) => {
        if (res.length > 0) {
          this.woGarmentList = res.map(result => ({
              garment: result,
              woOrder:"",
              garmentCode: result.garmentCode,
              garmentSummary: result.summary[0], 
              status:result.status,
              garmentDetails: result.details.filter(
                  (garment) => garment.garmentCode === result.garmentCode
              )[0] 
          }));
      }
  if(this.woGarmentList.length>0){
    this.isButtonDisabled=false;
    }
    else{
       this.isButtonDisabled=true;
    }
      this.loaded = true;
      });
       this.loaded = true;
    }
  

  addSelected(wo: WorkOrderProduct, event) {
    if (event.target.checked) {
      this.selectedWoProductList.push(wo);
    } else {
      //splice it out
      this.selectedWoProductList.splice(
        this.selectedWoProductList.indexOf(wo),
        1
      );
    }
  }

  // BackToPreviousPage(): void {
  
  //   this.router.navigate([`/route/logsheet/stop/${this.stopName}/employee-lookup/create-work-order/${this.customerCode}/${this.departmentCode}/${this.employeeCode}`]);
  // }

 
}
